import { PartnerSimple } from '~/api/links/_types';

export const useCategoryItemSideMenuStore = defineStore('category-item-side-menu', () => {
    const selectedPartner = ref<PartnerSimple>();
    const showDistributorPrice = ref(false);

    const reset = () => {
        selectedPartner.value = undefined;
        showDistributorPrice.value = false;
    };

    return {
        selectedPartner,
        showDistributorPrice,
        reset,
    };
});
